import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import local from "../../localization/strings";

const SwitchPeriodDropdown = (props) => {
	const [open, setOpen] = useState(false);

	return (
		<div className="dropdown-container">
			<div id={`${props.idx}_dropdown`} className={open ? "float-on-top" : "edit-dropdown"}>
				<Dropdown isOpen={open} toggle={() => setOpen(!open)}>
					<DropdownToggle tag="button" type="button" className="btn btn-outline fs-2 button-title">
						⋮
					</DropdownToggle>
					<DropdownMenu right className="menu-border">
						<DropdownItem header>{local.TF_Change_widget_period}:</DropdownItem>
						<DropdownItem id={`switchColour_${props.id}`} onClick={() => props.onSwitchPeriod(props.idx, "6Hours")}>
							{local.TF_6Hours}
						</DropdownItem>
						<DropdownItem id={`switchColour_${props.id}`} onClick={() => props.onSwitchPeriod(props.idx, "12Hours")}>
							{local.TF_12Hours}
						</DropdownItem>
						<DropdownItem id={`switchColour_${props.id}`} onClick={() => props.onSwitchPeriod(props.idx, "Day")}>
							{local.TS_Day}
						</DropdownItem>
						<DropdownItem id={`switchColour_${props.id}`} onClick={() => props.onSwitchPeriod(props.idx, "Week")}>
							{local.TS_Week}
						</DropdownItem>
						<DropdownItem id={`switchColour_${props.id}`} onClick={() => props.onSwitchPeriod(props.idx, "Month")}>
							{local.TS_Month}
						</DropdownItem>
					</DropdownMenu>
				</Dropdown>
			</div>
		</div>
	);
};

export default SwitchPeriodDropdown;
